import { render, staticRenderFns } from "./MypageOneTimePassWithNoPlanCompletePage.vue?vue&type=template&id=516a8e0f"
import script from "./MypageOneTimePassWithNoPlanCompletePage.vue?vue&type=script&lang=ts"
export * from "./MypageOneTimePassWithNoPlanCompletePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports